import {useState, useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import Swal from 'sweetalert2'
import {Loader} from '../../../../components/UI/Loader/Loader'
import {FormInputAndLabel} from '../../../../components/UI/Inputs/FormInputAndLabel'

import {IncorporadoraFormData, IncorporadoraFormSchema} from './formValidations'
import {useForm} from 'react-hook-form'
import {zodResolver} from '@hookform/resolvers/zod'

import {getLaunchesPartnersByID} from '../../../../../services/urbit-gis'
import ImageDropzone from '../../../components/DropzoneImage'

interface situacaoTerrenoProps {
  id: number
  show: boolean
  closeModal: any
}

export function EditForm({id, show, closeModal}: situacaoTerrenoProps) {
  const [loading, setLoading] = useState(true)
  const [image, setImage] = useState('')
  const [data, setData] = useState<IncorporadoraFormData>()
  const {
    handleSubmit,
    register,
    setValue,
    formState: {errors},
  } = useForm<IncorporadoraFormData>({
    resolver: zodResolver(IncorporadoraFormSchema),
  })

  useEffect(() => {
    if (image) {
      setValue('logo', image)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [image])

  useEffect(() => {
    const fetchLaunch = async () => {
      try {
        const result = await getLaunchesPartnersByID(id)
        console.log(result)
        setData(result)
        setLoading(false)
      } catch (error) {
        console.error('Erro ao buscar lançamento:', error)
        setLoading(false)
      }
    }

    fetchLaunch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const onSubmit = async (data) => {
    const formData = new FormData()
    formData.append('file', image)
    formData.append('nome', data.nome)
    formData.append('id', data.id.toString())

    let message = ''

    // Mostrar Swal de loading
    Swal.fire({
      title: 'Enviando Informações...',
      text: 'Por favor, aguarde.',
      icon: 'info',
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })
    const token = localStorage.getItem('token')
    await fetch(process.env.REACT_APP_API_GIS + `real_estate_launches_partners/update/${id}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        message =
          result.service !== 'error'
            ? 'Incoporadora atualizado com sucesso.'
            : result.message || 'Houve um erro ao atualizar a Incoporadora.'

        Swal.fire({
          title: result.service !== 'error' ? 'Sucesso!' : 'Erro!',
          text: message,
          icon: result.service !== 'error' ? 'success' : 'error',
          confirmButtonText: 'OK',
        }).then((result) => {
          closeModal()
        })
      })
  }

  if (loading || !data) {
    return (
      <Modal centered animation show={show} onHide={() => closeModal()}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Incorporadora</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Loader text={'caregando...'}></Loader>
        </Modal.Body>
      </Modal>
    )
  }

  console.log(errors)

  return (
    <>
      <Modal centered animation show={show} onHide={() => closeModal()}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Incorporadora</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            <input
              type='number'
              hidden
              className='form-control'
              defaultValue={data.id}
              {...register('id', {required: true, valueAsNumber: true})}
            />
            <div className='row'>
              <div className='col-md-12'>
                <div className='mb-6'>
                  <FormInputAndLabel
                    label='Codigo'
                    className='form-control required form-control-solid'
                    placeholder='Nome'
                    defaultValue={data.nome}
                    register={register('nome')}
                    error={errors ? errors.nome?.message : ''}
                  />
                </div>
              </div>
              <div className='col-md-12'>
                <ImageDropzone value={image} setImage={setImage} register={register('logo')} />
              </div>

              <div className='col-md-12 py-6 d-flex' style={{justifyContent: 'flex-end'}}>
                <button
                  className='btn btnSecondary  pull-right '
                  type='button'
                  onClick={() => closeModal()}
                >
                  Fechar
                </button>
                <button type='submit' className='btn btn-success mx-2'>
                  Salvar
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  )
}
